import { CONVERSION_FACTORS, MATERIAL_CONSTANTS } from '../constants/calculator_constants';

export type BendRadiusOpts = {
  E0?: number;
  ksiToMPa?: number;
};

export function computeBendRadiusFromKpsi(kpsi: number, fiberCladdingDiameter: number, opts: BendRadiusOpts = {}): number {
  const {
    E0 = MATERIAL_CONSTANTS.E0_MPA,
    ksiToMPa = CONVERSION_FACTORS.KSI_TO_MPA,
  } = opts;

  fiberCladdingDiameter = fiberCladdingDiameter / 1000000;

  const fiberCladdingRadius = fiberCladdingDiameter / 2; // meters
  const inside = 1 + 9.2 * ((kpsi * ksiToMPa) / E0);
  if (!isFinite(inside) || inside <= 0) return NaN;

  const value2 = Math.sqrt(inside) - 1;
  if (value2 === 0) return NaN;

  const value1 = 4.6 * fiberCladdingRadius;
  const R_m = value1 / value2; // meters
  return R_m * 1000; // mm
}

export default computeBendRadiusFromKpsi;